import { render } from "./BadgeComponent.vue?vue&type=template&id=00913834&scoped=true"
import script from "./BadgeComponent.vue?vue&type=script&lang=js"
export * from "./BadgeComponent.vue?vue&type=script&lang=js"

import "./BadgeComponent.vue?vue&type=style&index=0&id=00913834&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00913834"]])

export default __exports__